import { IPlacementCandidateContractDocEditor } from './types';

export const initialState: IPlacementCandidateContractDocEditor = {
  templates: [],
  selectedTemplate: null,
  catalogTemplates: [],
  mergeTokenList: {},
  miscellaneous: {},
  classicDraftExists: false,
  amieWebDraftExists: false,
  amieWebCreatedExists: false,
  pdfViewFromEditor: false,
  pendingTinyMceHtmlInsert: null,
};
